module.exports = "<div class=\"element-dialogue\" [@ArriveAnimation]=\"state\"> {{dialogue.content}} </div>\n"